<template>
  <div class="beneficios">
    <h2 class="section-title">
      Conheça todos benefícios de ter o Cartão de TODOS Sport!
    </h2>
    <div class="beneficios-container">
      <div>
        <div class="beneficios-card">
          <img
            class="beneficios-logo"
            src="./assets/logo-golstore.png"
            alt="Gol Store"
          />
          <h1 class="beneficios-title">10% de desconto</h1>
          <p class="beneficios-paragraph">
            Na loja online via cupom enviado para os filiados.
          </p>
        </div>
        <div class="beneficios-card">
          <img
            class="beneficios-logo"
            src="./assets/logo-decathlon.png"
            alt="Decathlon"
          />
          <h1 class="beneficios-title">5% de desconto</h1>
          <p class="beneficios-paragraph">
            Na loja online via cupom enviado para os filiados.
          </p>
        </div>
        <div class="beneficios-card">
          <img
            class="beneficios-logo beneficios-logo--light"
            src="@/assets/icons/home-saude.svg"
            alt="Saúde"
          />
          <h1 class="beneficios-title">Saúde</h1>
          <p class="beneficios-paragraph">
            Descontos em consultas e exames. Consultas a partir de R$
            {{ cdtPrices.clinico_geral }} em clínicas parceiras
          </p>
        </div>
        <div class="beneficios-card">
          <img
            class="beneficios-logo beneficios-logo--light"
            src="@/assets/icons/home-educacao.svg"
            alt="Educação"
          />
          <h1 class="beneficios-title">Educação</h1>
          <p class="beneficios-paragraph">
            30 dias gratuitos na Refuturiza: educação + empregabilidade
          </p>
        </div>
        <div class="beneficios-card">
          <img
            class="beneficios-logo beneficios-logo--light"
            src="@/assets/icons/home-lazer.svg"
            alt="Lazer"
          />
          <h1 class="beneficios-title">Lazer</h1>
          <p class="beneficios-paragraph">
            Descontos em supermercados, restaurantes e mais
          </p>
        </div>
      </div>
    </div>
    <svg
      class="beneficios-filtro"
      width="0"
      height="0"
      aria-hidden="true"
      focusable="false"
    >
      <filter id="beneficios-icone-amarelo" color-interpolation-filters="sRGB">
        <!-- Pinta qualquer pixel opaco de #FADC29, preservando o alfa do icone -->
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.98039
                  0 0 0 0 0.86275
                  0 0 0 0 0.16078
                  0 0 0 1 0"
        />
      </filter>
    </svg>
    <div class="beneficios-cta">
      <a class="cta-link" href="https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=27/" @click="handleCTAClick">
        Solicite seu Cartão
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { handleCTAClick } from "@/services/gtm";

export default {
  computed: {
    ...mapGetters(["cdtPrices"]),
  },
  methods: {
    handleCTAClick
  }
};
</script>

<style lang="scss">
.beneficios {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  padding-bottom: 54px;
  padding-top: 54px;
}

.section-title {
  color: #000;
  font-family: "Open Sans", sans-serif;
  font-size: 32px;
  font-weight: 800;
  line-height: 40px; /* 133.333% */
  text-align: center;
  margin-bottom: 32px;

  @media (max-width: 520px) {
    font-size: 24px;
    line-height: 36px; /* 150% */
  }
}

.beneficios-container {
  width: 100%;
  // 3 cards de 403px + 2 gaps de 32px
  max-width: 1273px;
  margin: 0 auto;

  @media (max-width: 1357px) {
    padding-left: 42px;
    padding-right: 42px;
  }

  @media (max-width: 520px) {
    overflow-x: scroll;
    width: 100%;
  }

  & > div {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    // Centraliza as linhas, inclusive a ultima, que fica incompleta
    justify-content: center;

    @media (max-width: 520px) {
      flex-wrap: nowrap;
      width: min-content;
    }
  }
}

.beneficios-card {
  align-items: center;
  background: $color-black;
  border-radius: 24px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 302px;
  justify-content: center;
  max-width: 100%;
  padding: 32px;
  text-align: center;
  width: 403px;

  @media (max-width: 520px) {
    aspect-ratio: 212 / 187;
    box-sizing: content-box;
    height: auto;
    min-width: 212px;
    width: auto;
  }
}

.beneficios-logo {
  display: block;
  height: auto;
  margin: 0 auto;
  max-height: 50px;
  max-width: 100%;
  object-fit: contain;

  // Os icones de saude, educacao e lazer sao SVGs pretos: sobre o card escuro
  // precisam ser convertidos para o amarelo #FADC29.
  &--light {
    filter: url("#beneficios-icone-amarelo");
  }
}

.beneficios-filtro {
  height: 0;
  position: absolute;
  width: 0;
}

.beneficios-title {
  color: $color-lightgray;
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.beneficios-paragraph {
  color: $color-lightgray;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.beneficios-cta {
  width: 100%;
  text-align: center;
}

.cta-link {
  display: block;
  width: fit-content;
  margin: 19px auto 0;
  padding: 13px 32px;
  background: $color-secondary;
  color: #000;
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  text-align: center;
  text-decoration: none;
  border-radius: 16px;
  transition: 0.3s ease-in-out;

  &:hover {
    background: $color-red;
  }

  @media (max-width: 520px) {
    width: 100%;
    max-width: 328px;
  }
}
</style>
